module.exports = {
  "radio": {
    "width": "36",
    "height": "36"
  },
  "title-text": {
    "fontSize": "30",
    "height": "40",
    "lineHeight": "40"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-33feed3d!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-radio/item.vue
// module id = 453
// module chunks = 0 1